import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import { AppBar, Toolbar, Box, IconButton, Divider, MenuList, MenuItem, Drawer, Typography, Popper, Paper, Fade, ListItemIcon, ListItemText, Switch, Stack, } from '@mui/material';
import { CloseRounded, ExpandLess, ExpandMore, Badge, TableView, Article, Reply, ArrowRight, Menu as MenuIcon  } from '@mui/icons-material';
import PropTypes from "prop-types";

import Link from "./Link";
import Sitemark, { CustomIcon  } from './SitemarkIcon';
import AuthButton from "../../layouts/headerUiEl/AuthButton";


const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexShrink: 0,
  // borderRadius: `calc(${theme.shape.borderRadius}px + 2px)`,
  backdropFilter: 'blur(24px)',
  border: 'none',
  // borderColor: (theme.vars || theme).palette.divider,
  backgroundColor: theme.vars
    ? `rgba(${theme.vars.palette.background.defaultChannel} / 0.4)`
    : alpha(theme.palette.background.default, 0.4),
  boxShadow: (theme.vars || theme).shadows[1],
  padding: '8px 12px',
  width: "100%",
  maxWidth: '100%',
  maxHeight: `${process.env.REACT_APP_HEADER_SIZE}`,
  overflow: 'hidden',
}));

const GradientTypography = styled(Typography)({
  background: "transparent",
  color: "transparent",
  overflow: "hidden",
  WebkitBackgroundClip: "text",
  backgroundClip: "text",
  backgroundImage: "linear-gradient(45deg, #003399 30%, #CC0066 90%)",
  "&:hover": {
    backgroundImage: "linear-gradient(45deg, #CC0066 30%, #003399 90%)",
  },
});


/*
    2025.04.24 모바일 기기를 지원하는 메뉴 구조 적용
*/
export default function MyAppBar({ auth, t, handleChangeLanguage, i18n }) {
  const [open, setOpen] = React.useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openMobileMenu, setOpenMobileMenu] = React.useState(false);
  const menuColor = "#202124";
  const menuSubItemHeight = "42px";

  const toggleDrawer = (newOpen) => () => {
    setOpenMobileMenu(newOpen);
  };

  const handleClick = () => {
    setOpen(null);
    setAnchorEl(null);
  };

  const handleHide = () => {
    if (window.pageYOffset > 100 && open !== null) handleClick();
  }

  const handleShowMenuClick = (event, menuid) => {
    handleClick();
    setOpen(menuid)
    if (anchorEl !== event.currentTarget) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleLanguageChange = (event) => {
    handleChangeLanguage(event.target.checked ? 'en' : 'ko');
  };
  
    
  React.useEffect(() => {
      const watch = () => {
          window.addEventListener('scroll', handleHide)
      }
      watch();
      return () => {
          window.removeEventListener('scroll', handleHide)
      }
  });


  return (
    <AppBar
      position="fixed"
      enableColorOnDark
      sx={{
        boxShadow: 0,
        bgcolor: 'transparent',
        mt: 'calc(var(--template-frame-height, 0px) + 0px)',
      }}
      className='my-app-bar'
    >
      <Box sx={{ display: 'flex', width: '100%', maxWidth: '100%' }} onMouseLeave={handleClick}>
        <StyledToolbar variant="dense" disableGutters>
          {/* 테스크탑인 메뉴 */}
          <Box sx={{ flexGrow: 1, display: 'flex', px: 0, width: "100%", }}>
            {/* 사이트 로고 */}
            <Sitemark onMouseOver={handleClick} />
            {/* 사이트 메뉴 */}
            <Box sx={{ display: { xs: 'none', sm: 'none',  md: 'flex', width: '100%', alignItems: 'cnter', justifyContent: 'center' } }}>

              {/* About BWOB(Best Wave Of Busan) */}  
              <Link href="/intro" sx={{ my: 1, mx: 1.5, }} underline="none" >
                <MenuItem variant="text" size="small" sx={{ minWidth: '120px' }} onClick={handleClick} onMouseOver={handleClick}>
                  <ListItemText component="div" sx={{ flexGrow: 1, color: menuColor }}>{t('nav.about')}</ListItemText>
                </MenuItem>
              </Link>

              {/* 생두 정보 */}
              <Link sx={{ my: 1, mx: 1.5 }} underline="none" >
                <MenuItem id='beens-button' variant='text' sx={{ minWidth: '120px' }} 
                        aria-controls={open ?? undefined} aria-expanded={open === 'beens-menu' ? 'true' : undefined} aria-owns={open ?? undefined} aria-haspopup='true'
                        size="small" onClick={(e) => handleShowMenuClick(e, 'beens-menu')} onMouseOver={(e) => handleShowMenuClick(e, 'beens-menu')}>
                  <ListItemText component="div" sx={{ flexGrow: 1, color: menuColor }}>{t('nav.beensinfo')}</ListItemText>
                  {open === 'beens-menu' ? <ExpandLess /> : <ExpandMore />}
                </MenuItem>
                <Popper id='beens-menu' aria-labelledby='beens-button' anchorEl={anchorEl} open={open === 'beens-menu'} getContentAnchorEl={null}
                      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} transformOrigin={{ vertical: 'top', horizontal: 'right' }} 
                      sx={{ zIndex: 15000 }} transition
                      onClose={handleClick} onMouseLeave={handleClick}>
                  {({ TransitionProps }) => (
                    <Fade {...TransitionProps} timeout={100}>
                      <Box sx={{ p: 1, m: 0 }}>
                        <Paper sx={{ bgcolor: '#fefefe', minWidth: '200px' }}>
                          <MenuList component="div" disablePadding>

                            <Link href="/search" underline="none" onClick={handleClick} sx={{ width: '100%' }}>
                              <MenuItem sx={{ lineHeight: menuSubItemHeight, height: menuSubItemHeight, p: 0, m: 0, paddingLeft: '20px', borderBottom: '1px dotted #CFCBCF'  }}>
                                <ListItemIcon sx={{ p: 0, m: 0, justifyContent: 'start', minWidth: '30px' }}>
                                  <ArrowRight color="primary" variant="dot" invisible={false} fontSize="small" />
                                </ListItemIcon>
                                <ListItemText component="div" sx={{ flexGrow: 1, color: menuColor, }}>{t('nav.search')}</ListItemText>
                              </MenuItem>
                            </Link>

                            <Link href="/mypage" underline="none" onClick={handleClick} sx={{ width: '100%' }}>
                              <MenuItem sx={{ lineHeight: menuSubItemHeight, height: menuSubItemHeight, p: 0, m: 0, paddingLeft: '20px', borderBottom: '1px dotted #CFCBCF'  }}>
                                <ListItemIcon sx={{ p: 0, m: 0, justifyContent: 'start', minWidth: '30px' }}>
                                  <ArrowRight color="primary" variant="dot" invisible={false} fontSize="small" />
                                </ListItemIcon>
                                <ListItemText component="div" sx={{ flexGrow: 1, color: menuColor, }}>{t('nav.mypage')}</ListItemText>
                              </MenuItem>
                            </Link>

                            <Link href="/statistics" underline="none" onClick={handleClick} sx={{ width: '100%' }}>
                              <MenuItem sx={{ lineHeight: menuSubItemHeight, height: menuSubItemHeight, p: 0, m: 0, paddingLeft: '20px' }}>
                                <ListItemIcon sx={{ p: 0, m: 0, justifyContent: 'start', minWidth: '30px' }}>
                                  <ArrowRight color="primary" variant="dot" invisible={false} fontSize="small" />
                                </ListItemIcon>
                                <ListItemText component="div" sx={{ flexGrow: 1, color: menuColor, }}>{t('nav.statics')}</ListItemText>
                              </MenuItem>
                            </Link>

                          </MenuList>
                        </Paper>
                      </Box>
                    </Fade>
                  )}
                </Popper>
              </Link>

              {/* 고객지원 */}
              <Link sx={{ my: 1, mx: 1.5 }} underline="none" >
                <MenuItem id='customer-button' variant='text' sx={{ minWidth: '120px' }} 
                        aria-controls={open ?? undefined} aria-expanded={open === 'customer-menu' ? 'true' : undefined} aria-owns={open ?? undefined} aria-haspopup='true'
                        size="small" onClick={(e) => handleShowMenuClick(e, 'customer-menu')} onMouseOver={(e) => handleShowMenuClick(e, 'customer-menu')}>
                  <ListItemText component="div" sx={{ flexGrow: 1, color: menuColor }}>{t('nav.customersupport')}</ListItemText>
                  {open === 'customer-menu' ? <ExpandLess /> : <ExpandMore />}
                </MenuItem>
                <Popper id='customer-menu' aria-labelledby='customer-button' anchorEl={anchorEl} open={open === 'customer-menu'} getContentAnchorEl={null} 
                      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} transformOrigin={{ vertical: 'top', horizontal: 'center' }} 
                      sx={{ zIndex: 15000 }} transition
                      onClose={handleClick} onMouseLeave={handleClick}>
                  {({ TransitionProps }) => (
                    <Fade {...TransitionProps} timeout={100}>
                      <Box sx={{ p: 1, m: 0 }}>
                        <Paper sx={{ bgcolor: '#fefefe', minWidth: '200px' }}>
                          <MenuList component="div" disablePadding>

                            <Link href="/faq" underline="none" onClick={handleClick} sx={{ width: '100%' }}>
                              <MenuItem sx={{ lineHeight: menuSubItemHeight, height: menuSubItemHeight, p: 0, m: 0, paddingLeft: '20px', borderBottom: '1px dotted #CFCBCF'  }}>
                                <ListItemIcon sx={{ p: 0, m: 0, justifyContent: 'start', minWidth: '30px' }}>
                                  <ArrowRight color="primary" variant="dot" invisible={false} fontSize="small" />
                                </ListItemIcon>
                                <ListItemText component="div" sx={{ flexGrow: 1, color: menuColor, }}>{t('nav.board1')}</ListItemText>
                              </MenuItem>
                            </Link>

                            <Link href="/qna" underline="none" onClick={handleClick} sx={{ width: '100%' }}>
                              <MenuItem sx={{ lineHeight: menuSubItemHeight, height: menuSubItemHeight, p: 0, m: 0, paddingLeft: '20px', borderBottom: '1px dotted #CFCBCF'  }}>
                                <ListItemIcon sx={{ p: 0, m: 0, justifyContent: 'start', minWidth: '30px' }}>
                                  <ArrowRight color="primary" variant="dot" invisible={false} fontSize="small" />
                                </ListItemIcon>
                                <ListItemText component="div" sx={{ flexGrow: 1, color: menuColor, }}>{t('nav.board2')}</ListItemText>
                              </MenuItem>
                            </Link>

                            <Link href="/board" underline="none" onClick={handleClick} sx={{ width: '100%' }}>
                              <MenuItem sx={{ lineHeight: menuSubItemHeight, height: menuSubItemHeight, p: 0, m: 0, paddingLeft: '20px' }}>
                                <ListItemIcon sx={{ p: 0, m: 0, justifyContent: 'start', minWidth: '30px' }}>
                                  <ArrowRight color="primary" variant="dot" invisible={false} fontSize="small" />
                                </ListItemIcon>
                                <ListItemText component="div" sx={{ flexGrow: 1, color: menuColor, }}>{t('nav.board3')}</ListItemText>
                              </MenuItem>
                            </Link>

                          </MenuList>
                        </Paper>
                      </Box>
                    </Fade>
                  )}
                </Popper>
              </Link>
              
              {/* 관리자 메뉴 또는 링크 */}
              {(auth?.userId?.length > 0 && auth?.userType === process.env.REACT_APP_BOARD_MANAGER_TYPE) ?
              <Link sx={{ my: 1, mx: 1.5,  }} underline="none" >
                <MenuItem id='management-button' variant='text' sx={{ minWidth: '120px' }} 
                        aria-controls={open ?? undefined} aria-expanded={open === 'management-menu' ? 'true' : undefined} aria-owns={open ?? undefined} aria-haspopup='true'
                        size="small" onClick={(e) => handleShowMenuClick(e, 'management-menu')} onMouseOver={(e) => handleShowMenuClick(e, 'management-menu')}>
                  <ListItemText component="div" sx={{ flexGrow: 1, color: menuColor }}>{t('nav.management')}</ListItemText>
                  {open === 'management-menu' ? <ExpandLess /> : <ExpandMore />}
                </MenuItem>
                <Popper id='management-menu' aria-labelledby='management-button' anchorEl={anchorEl} open={open === 'management-menu'} getContentAnchorEl={null}
                      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                      sx={{ zIndex: 15000 }} transition
                      onClose={handleClick} onMouseLeave={handleClick}>
                  {({ TransitionProps }) => (
                    <Fade {...TransitionProps} timeout={100}>
                      <Box sx={{ p: 1, m: 0 }}>
                        <Paper sx={{ bgcolor: '#fefefe', minWidth: '200px', padding: '4px' }}>
                          <MenuList component="div" disablePadding>
                            
                            <Link href="/manage4member" underline="none" onClick={handleClick}>
                              <MenuItem sx={{ lineHeight: menuSubItemHeight, height: menuSubItemHeight, p: 0, m: 0, paddingLeft: '20px', borderBottom: '1px dotted #CFCBCF'  }}>
                                <ListItemIcon sx={{ p: 0, m: 0, justifyContent: 'start', minWidth: '30px' }}>
                                  <Badge color="primary" variant="dot" invisible={false} sx={{ mr: 1 }} fontSize="small" />
                                </ListItemIcon>
                                <ListItemText component="div" sx={{ flexGrow: 1, color: menuColor }}>{t('nav.manage4member')}</ListItemText>
                              </MenuItem>
                            </Link>

                            <Link href="/manage4board" underline="none" onClick={handleClick}>
                              <MenuItem sx={{ lineHeight: menuSubItemHeight, height: menuSubItemHeight, p: 0, m: 0, paddingLeft: '20px', borderBottom: '1px dotted #CFCBCF'  }}>
                                <ListItemIcon sx={{ p: 0, m: 0, justifyContent: 'start', minWidth: '30px' }}>
                                  <TableView color="primary" variant="dot" invisible={false} sx={{ mr: 1 }} fontSize="small" />
                                </ListItemIcon>
                                <ListItemText component="div" sx={{ flexGrow: 1, color: menuColor }}>{t('nav.manage4board')}</ListItemText>
                              </MenuItem>
                            </Link>

                            <Link href="/manage4article" underline="none" onClick={handleClick}>
                              <MenuItem sx={{ lineHeight: menuSubItemHeight, height: menuSubItemHeight, p: 0, m: 0, paddingLeft: '20px', borderBottom: '1px dotted #CFCBCF'  }}>
                                <ListItemIcon sx={{ p: 0, m: 0, justifyContent: 'start', minWidth: '30px' }}>
                                  <Article color="primary" variant="dot" invisible={false} sx={{ mr: 1 }} fontSize="small" />
                                </ListItemIcon>
                                <ListItemText component="div" sx={{ flexGrow: 1, color: menuColor }}>{t('nav.manage4article')}</ListItemText>
                              </MenuItem>
                            </Link>
                            
                            <Link href="/manage4reply" underline="none" onClick={handleClick}>
                              <MenuItem sx={{ lineHeight: menuSubItemHeight, height: menuSubItemHeight, p: 0, m: 0, paddingLeft: '20px' }}>
                                <ListItemIcon sx={{ p: 0, m: 0, justifyContent: 'start', minWidth: '30px' }}>
                                  <Reply color="primary" variant="dot" invisible={false} sx={{ mr: 1 }} fontSize="small" />
                                </ListItemIcon>
                                <ListItemText component="div" sx={{ flexGrow: 1, color: menuColor }}>{t('nav.manage4reply')}</ListItemText>
                              </MenuItem>
                            </Link>

                          </MenuList>
                        </Paper>
                      </Box>
                    </Fade>
                  )}
                </Popper>
              </Link>
              : 
              <Link href="http://thecoffee.auction/" sx={{ my: 1, mx: 1.5 }} underline="none" target="_blank">
                <MenuItem variant="text" size="small" sx={{ minWidth: '120px' }} onMouseOver={handleClick}>
                  <ListItemIcon sx={{ p: 0, m: 0, justifyContent: 'start', minWidth: '30px' }}>
                    <CustomIcon color="primary" variant="dot" invisible={false} fontSize="small" />
                  </ListItemIcon>
                  <ListItemText> Coffee
                    <GradientTypography component="span"> Auction</GradientTypography>
                  </ListItemText>
                </MenuItem>
              </Link> }
            </Box>
            {/* 테스크탑인 경우 로그인/로그아웃 */}
            <Box sx={{ display: { xs: 'none', sm: 'none',  md: 'flex' }, gap: 1, alignItems: 'center', }}>
              <AuthButton onMouseOver={handleClick} />
            </Box>
          </Box>

          {/* 모바일 메뉴 */}
          <Box sx={{ display: { xs: 'flex', sm: 'flex',  md: 'none' }, gap: 1 }} onMouseLeave={toggleDrawer(false)}>
            <IconButton aria-label="Menu button" onClick={toggleDrawer(true)}>
              <MenuIcon />
            </IconButton>
            <Drawer anchor="top" open={openMobileMenu} onClose={toggleDrawer(false)}
              PaperProps={{
                sx: {
                  top: 'var(--template-frame-height, 0px)',
                },
              }}
            >
              <Box sx={{ p: 2, backgroundColor: 'background.default' }}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', }}>
                  <Stack direction="row" spacing={1} alignItems="center" sx={{ flexGrow: 1, }}>
                    <Typography>한국어</Typography>
                    <Switch checked={i18n.language.toLowerCase() !== 'ko'} onChange={handleLanguageChange} inputProps={{ 'aria-label': 'controlled' }} />
                    <Typography>English</Typography>
                  </Stack>
                  <IconButton onClick={toggleDrawer(false)}>
                    <CloseRounded />
                  </IconButton>
                </Box>
                
                <Divider sx={{ my: 1 }} />
                <Link href="/intro" underline="none" onClick={toggleDrawer(false)} >
                  <MenuItem sx={{ lineHeight: menuSubItemHeight, height: menuSubItemHeight, p: 0, m: 0, paddingLeft: '20px', borderBottom: '1px dotted #CFCBCF' }}>
                      <ListItemIcon sx={{ p: 0, m: 0, justifyContent: 'start', minWidth: '30px' }}>
                        <ArrowRight color="primary" variant="dot" invisible={false} sx={{ mr: 1 }} fontSize="small" />
                      </ListItemIcon>
                      <ListItemText component="span" sx={{ color: menuColor }}>{t('nav.about')}</ListItemText>
                  </MenuItem>
                </Link>

                <>
                <Link href="/search" underline="none" onClick={toggleDrawer(false)} >
                  <MenuItem sx={{ lineHeight: menuSubItemHeight, height: menuSubItemHeight, p: 0, m: 0, paddingLeft: '20px' }}>
                    <ListItemIcon sx={{ p: 0, m: 0, justifyContent: 'start', minWidth: '30px' }}>
                      <ArrowRight color="primary" variant="dot" invisible={false} sx={{ mr: 1 }} fontSize="small" />
                    </ListItemIcon>
                    <ListItemText component="span" sx={{ color: menuColor }}>{t('nav.search')}</ListItemText>
                  </MenuItem>
                </Link>
                <Link href="/mypage" underline="none" onClick={toggleDrawer(false)} >
                  <MenuItem sx={{ lineHeight: menuSubItemHeight, height: menuSubItemHeight, p: 0, m: 0, paddingLeft: '20px' }}>
                    <ListItemIcon sx={{ p: 0, m: 0, justifyContent: 'start', minWidth: '30px' }}>
                      <ArrowRight color="primary" variant="dot" invisible={false} sx={{ mr: 1 }} fontSize="small" />
                    </ListItemIcon>
                    <ListItemText component="span" sx={{ color: menuColor }}>{t('nav.mypage')}</ListItemText>
                  </MenuItem>
                </Link>
                <Link href="/statistics" underline="none" onClick={toggleDrawer(false)} >
                  <MenuItem sx={{ lineHeight: menuSubItemHeight, height: menuSubItemHeight, p: 0, m: 0, paddingLeft: '20px', borderBottom: '1px dotted #CFCBCF'  }}>
                    <ListItemIcon sx={{ p: 0, m: 0, justifyContent: 'start', minWidth: '30px' }}>
                      <ArrowRight color="primary" variant="dot" invisible={false} sx={{ mr: 1 }} fontSize="small" />
                    </ListItemIcon>
                    <ListItemText component="span" sx={{ color: menuColor }}>{t('nav.statics')}</ListItemText>
                  </MenuItem>
                </Link>
                </>

                <>
                <Link href="/faq" underline="none" onClick={toggleDrawer(false)} >
                  <MenuItem sx={{ lineHeight: menuSubItemHeight, height: menuSubItemHeight, p: 0, m: 0, paddingLeft: '20px' }}>
                    <ListItemIcon sx={{ p: 0, m: 0, justifyContent: 'start', minWidth: '30px' }}>
                      <ArrowRight color="primary" variant="dot" invisible={false} sx={{ mr: 1 }} fontSize="small" />
                    </ListItemIcon>
                    <ListItemText component="span" sx={{ color: menuColor }}>{t('nav.board1')}</ListItemText>
                  </MenuItem>
                </Link>
                <Link href="/qna" underline="none" onClick={toggleDrawer(false)} >
                  <MenuItem sx={{ lineHeight: menuSubItemHeight, height: menuSubItemHeight, p: 0, m: 0, paddingLeft: '20px' }}>
                    <ListItemIcon sx={{ p: 0, m: 0, justifyContent: 'start', minWidth: '30px' }}>
                      <ArrowRight color="primary" variant="dot" invisible={false} sx={{ mr: 1 }} fontSize="small" />
                    </ListItemIcon>
                    <ListItemText component="span" sx={{ color: menuColor }}>{t('nav.board2')}</ListItemText>
                  </MenuItem>
                </Link>
                <Link href="/board" underline="none" onClick={toggleDrawer(false)} >
                  <MenuItem sx={{ lineHeight: menuSubItemHeight, height: menuSubItemHeight, p: 0, m: 0, paddingLeft: '20px', borderBottom: '1px dotted #CFCBCF' }}>
                    <ListItemIcon sx={{ p: 0, m: 0, justifyContent: 'start', minWidth: '30px' }}>
                      <ArrowRight color="primary" variant="dot" invisible={false} sx={{ mr: 1 }} fontSize="small" />
                    </ListItemIcon>
                    <ListItemText component="span" sx={{ color: menuColor }}>{t('nav.board3')}</ListItemText>
                  </MenuItem>
                </Link>
                </>

                <>
                {(auth?.userId?.length > 0 && auth?.userType === process.env.REACT_APP_BOARD_MANAGER_TYPE) ?
                <>
                  <Link href="/manage4member" underline="none" onClick={toggleDrawer(false)} >
                    <MenuItem sx={{ lineHeight: menuSubItemHeight, height: menuSubItemHeight, p: 0, m: 0, paddingLeft: '20px' }}>
                      <ListItemIcon sx={{ p: 0, m: 0, justifyContent: 'start', minWidth: '30px' }}>
                        <ArrowRight color="primary" variant="dot" invisible={false} sx={{ mr: 1 }} fontSize="small" />
                      </ListItemIcon>
                      <ListItemText component="span" sx={{ color: menuColor }}>{t('nav.manage4member')}</ListItemText>
                    </MenuItem>
                  </Link>
                  <Link href="/manage4board" underline="none" onClick={toggleDrawer(false)} >
                    <MenuItem sx={{ lineHeight: menuSubItemHeight, height: menuSubItemHeight, p: 0, m: 0, paddingLeft: '20px' }}>
                      <ListItemIcon sx={{ p: 0, m: 0, justifyContent: 'start', minWidth: '30px' }}>
                        <ArrowRight color="primary" variant="dot" invisible={false} sx={{ mr: 1 }} fontSize="small" />
                      </ListItemIcon>
                      <ListItemText component="span" sx={{ color: menuColor }}>{t('nav.manage4board')}</ListItemText>
                    </MenuItem>
                  </Link>
                  <Link href="/manage4article" underline="none" onClick={toggleDrawer(false)} >
                    <MenuItem sx={{ lineHeight: menuSubItemHeight, height: menuSubItemHeight, p: 0, m: 0, paddingLeft: '20px' }}>
                      <ListItemIcon sx={{ p: 0, m: 0, justifyContent: 'start', minWidth: '30px' }}>
                        <ArrowRight color="primary" variant="dot" invisible={false} sx={{ mr: 1 }} fontSize="small" />
                      </ListItemIcon>
                      <ListItemText component="span" sx={{ color: menuColor }}>{t('nav.manage4article')}</ListItemText>
                    </MenuItem>
                  </Link>
                  <Link href="/manage4reply" underline="none" onClick={toggleDrawer(false)} >
                    <MenuItem sx={{ lineHeight: menuSubItemHeight, height: menuSubItemHeight, p: 0, m: 0, paddingLeft: '20px', borderBottom: '1px dotted #CFCBCF' }}>
                      <ListItemIcon sx={{ p: 0, m: 0, justifyContent: 'start', minWidth: '30px' }}>
                        <ArrowRight color="primary" variant="dot" invisible={false} sx={{ mr: 1 }} fontSize="small" />
                      </ListItemIcon>
                      <ListItemText component="span" sx={{ color: menuColor }}>{t('nav.manage4reply')}</ListItemText>
                    </MenuItem>
                  </Link>
                </>
                : 
                <Link href="http://thecoffee.auction/" underline="none" onClick={toggleDrawer(false)}>
                  <MenuItem sx={{ lineHeight: menuSubItemHeight, height: menuSubItemHeight, p: 0, m: 0, paddingLeft: '20px', borderBottom: '1px dotted #CFCBCF' }}>
                    <ListItemIcon sx={{ p: 0, m: 0, justifyContent: 'start', minWidth: '30px' }}>
                      <ArrowRight color="primary" variant="dot" invisible={false} sx={{ mr: 1 }} fontSize="small" />
                    </ListItemIcon>
                    <ListItemText component="span" sx={{ color: menuColor }}>Coffee Auction</ListItemText>
                  </MenuItem>
                </Link> }
                </>

                <MenuItem>
                  <AuthButton onClick={setOpenMobileMenu} />
                </MenuItem>

              </Box>
            </Drawer>
          </Box>
        </StyledToolbar>
      </Box>
    </AppBar>
  );
};

MyAppBar.propTypes = {
  auth: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  handleChangeLanguage: PropTypes.func.isRequired,
  i18n: PropTypes.object.isRequired,
}
